"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconNikePlus = Experimental__IconNikePlus;
exports.IconNikePlus = IconNikePlus;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconNikePlus/index.tsx)
 */
function IconNikePlus(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M2.238 8.397a1.351 1.351 0 0 1-.52-.738 1.71 1.71 0 0 1 0-.909c.082-.31.17-.57.262-.782.093-.211.192-.402.298-.571-.715.777-1.23 1.407-1.548 1.889A5.434 5.434 0 0 0 .198 8.34C.071 8.69.005 9.028 0 9.353c-.005.325.069.61.222.853.625 1 1.98 1.061 4.064.183L16 5.444 4.429 8.5c-1.01.265-1.74.23-2.19-.103h-.001zm13.254 1.698H14.08a.16.16 0 0 1-.135-.063.217.217 0 0 1-.04-.151l.247-1.365a.175.175 0 0 0-.036-.15.17.17 0 0 0-.14-.064h-.332a.251.251 0 0 0-.163.063.256.256 0 0 0-.091.15l-.238 1.366a.253.253 0 0 1-.091.15.25.25 0 0 1-.163.064h-1.365a.286.286 0 0 0-.175.06.23.23 0 0 0-.095.147l-.056.333c-.027.132.026.198.16.198h1.404c.058 0 .103.021.135.064a.214.214 0 0 1 .04.15l-.247 1.397a.17.17 0 0 0 .036.147c.035.04.08.06.139.06h.333c.058 0 .112-.02.16-.06a.248.248 0 0 0 .086-.147l.246-1.396a.251.251 0 0 1 .092-.151.245.245 0 0 1 .162-.064h1.365c.16 0 .25-.066.27-.198l.064-.333c.026-.138-.027-.207-.16-.207z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M4.798 10.75a1.69 1.69 0 0 1-.65-.923 2.137 2.137 0 0 1 0-1.136c.102-.386.211-.712.327-.977.116-.264.24-.502.373-.714-.894.972-1.539 1.759-1.935 2.361a6.793 6.793 0 0 0-.665 1.318c-.159.437-.241.86-.248 1.266-.006.407.086.762.278 1.066.78 1.25 2.474 1.326 5.08.229L22 7.059l-14.464 3.82c-1.263.33-2.175.288-2.737-.13h-.001zm16.567 2.122H19.6a.2.2 0 0 1-.169-.078.272.272 0 0 1-.05-.19l.309-1.705a.218.218 0 0 0-.045-.188.212.212 0 0 0-.174-.08h-.416a.314.314 0 0 0-.204.079.32.32 0 0 0-.113.187l-.298 1.708a.316.316 0 0 1-.114.187.31.31 0 0 1-.203.08h-1.707a.357.357 0 0 0-.218.075.287.287 0 0 0-.12.184l-.07.416c-.032.165.034.248.2.248h1.756a.2.2 0 0 1 .169.08.27.27 0 0 1 .05.187l-.31 1.747a.212.212 0 0 0 .046.183c.043.05.101.075.174.075h.416c.073 0 .14-.025.2-.075a.31.31 0 0 0 .107-.183l.308-1.745a.314.314 0 0 1 .115-.19.306.306 0 0 1 .202-.08h1.707c.199 0 .311-.082.337-.247l.08-.416c.033-.172-.033-.259-.199-.259h-.001z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconNikePlus is deprecated and will be archived soon. Use IconNikePlus instead.
 */
function Experimental__IconNikePlus(props) {
  return /*#__PURE__*/_react["default"].createElement(IconNikePlus, props);
}